<div>
  <iframe [src]="fileUrl | safe : 'resourceUrl'" width="100%" height="700px" frameborder="0"></iframe>
</div>
